import React, { memo } from 'react';

import { DoneIcon, HourglassIcon, UploadIcon } from 'components/common/Icons/Icons';

import styles from './UploadInformational.module.scss';

const UploadInformation = memo(() => {
  return (
    <div className={styles.uploadInformationBlock}>
      <div className={styles.uploadInformationText}>
        <UploadIcon />
        Upload – Please drag the required files to the designated label or just click ‘upload’.
      </div>
      <div className={styles.uploadInformationText}>
        <HourglassIcon />
        Received – Your upload has been received. Please allow me up to 48 business hours to review your upload(s) for
        for accuracy.
      </div>
      <div className={styles.uploadInformationText}>
        <DoneIcon />
        Completed – HFS has reviewed and accepted the required document upload. Once all items are marked completed, we
        will move your file to underwriting.
      </div>
    </div>
  );
});

export default UploadInformation;
